import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'
import { initSession } from './auth/session'

// Antes de renderizar: lee `?cotalker-token=…`, lo borra de la URL en el acto
// y deja escuchando el canal postMessage. Corre SIEMPRE, también con fixtures
// configurados — si llega un token real, el repositorio lo prefiere y muestra
// datos de verdad en vez de los de muestra.
initSession()

const container = document.getElementById('root')
if (!container) throw new Error('Falta #root en index.html')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
